import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-header-atricon',
  standalone: false,
  templateUrl: './header-atricon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header-atricon.component.css'
})
export class HeaderAtriconComponent {
}
